import { getGeocode } from 'use-places-autocomplete';

import { ZIP_REGEX } from './formatting';
import { heapTrackClientError } from './logging';

// Validate the length and formatting of the given zip code value
export const validateZip = (zip: string) => zip && ZIP_REGEX.test(zip);

// Calls the Google Geocoding API to find the state associated with a given zip code
export const getStateFromZip = async (zip: string) => {
  try {
    // Restrict geocoding results to US for partial/ambigious search optimization
    const results = await getGeocode({
      address: zip,
      componentRestrictions: { country: 'US' },
    });
    if (results && results[0] && results[0].address_components) {
      const addressComponents = results[0].address_components;
      const state = addressComponents
        // Within the US, 'administrative_area_level_1' are states
        .filter(
          (component) => component.types[0] === 'administrative_area_level_1'
        )
        // Only care about the state's 2-letter postal abbreviation
        .map(({ short_name }) => short_name);
      return state[0];
    }
    heapTrackClientError({
      errorMessage:
        'Unexpected response from use-places-autocomplete getGeocode',
    });
    return null;
  } catch (error: any) {
    // Error type from the API response is always a string
    throw new Error(error);
  }
};
